<template>
    <div class="sandbox-navigation">
        <m-navigation @item-click="onItemClick">
            <mds-navigation-link :title='menuItem.title' :text='menuItem.title' slot="content" v-for="(menuItem, menuIndex) in contentDropDownDetails" :key="'Dropdown' + menuIndex">
                <span slot='submenu'>
                    <m-dropdown data-type="menu" v-if="menuItem.child && menuItem.child.length > 0">
                        <mds-navigation-link :item="JSON.stringify(menuSubItem)" href='' :text="menuSubItem.title" slot="content" v-for="(menuSubItem, menuSubItemIndex) in menuItem.child" :key="menuSubItemIndex" :current="menuSubItem.active"></mds-navigation-link>
                    </m-dropdown>
                </span>
            </mds-navigation-link>
            <mds-navigation-link :item="JSON.stringify(menuItem)" href='' :title='menuItem.title' :text='menuItem.title' slot="corporate" v-for="(menuItem, menuIndex) in contentWithoutDropDownDetails" :key="'Normal' + menuIndex"></mds-navigation-link>
            <mds-navigation-link text='Mijn Mediq' icon='single-user' slot="commerce" v-if="commerceDetails">
                <span slot='submenu'>
                    <m-dropdown data-type='menu' :data-title="commerceDetails.title">
                        <mds-navigation-link :item="JSON.stringify(subItem)" href='' :text="subItem.title" slot="content" v-for="(subItem, index) in commerceDetails.child" :key="index"></mds-navigation-link>
                    </m-dropdown>
                </span>
            </mds-navigation-link>
        </m-navigation>
    </div>
  </template>
  
  <script>
    import store from '@/store'
    import router from '@/router'
    import { mapActions } from 'vuex'
    import { EventBus } from '@/components/shared/event-bus.js'
    import { pushDepartmentChangedEvent } from '@/components/sections/navigation/departmentChangedEventStream'
    import { availableDepartments$, activeDepartment$, left$ } from '@/services';
    import { tap } from 'rxjs/operators'
    import { combineLatest } from 'rxjs';
    import {
      formLogout,
      currentUserIdentity$,
      availablePortals$,
      pushActivePortalCode,
    } from '@/services';
  
    export default {
      data () {
        return {
          collapsed: false,
          navigationArray: []
        }
      },
      computed: {
        contentDropDownDetails () {
            return this.navigationArray.filter((navigationArrayItem) => {
                return navigationArrayItem.type !== 'user' && navigationArrayItem.child && navigationArrayItem.child.length > 0
            })
        },
        contentWithoutDropDownDetails () {
          return this.navigationArray.filter((navigationArrayItem) => {
                return navigationArrayItem.type !== 'user' && !navigationArrayItem.child
            })
        },
        commerceDetails () {
            let computedDetails = this.navigationArray.filter((navigationArrayItem) => {
                return navigationArrayItem.type === 'user'
            })
            return computedDetails[0]
        }
      },
      subscriptions () {
        return {
          availableDepartments: availableDepartments$,
          activeDepartment: activeDepartment$,
          availablePortals: availablePortals$,
          user: currentUserIdentity$,
          results: combineLatest(currentUserIdentity$, left$, availablePortals$, (user, left, availablePortals) => {
            return {
              left: left,
              user: user,
              availablePortals: availablePortals
            };
          }).pipe(
            tap(data => {
              // Patching `store` with synchronized data
              store.dispatch('navigation/updateResults', data.left).then(results => {
                var navdata = {...data.left, user: data.user, availablePortals: data.availablePortals };
                this.initNavigation(navdata); // Local creation of menu
              });
            })
          )
        };
      },
      props: {
        auth: {
          type: Boolean,
          required: false,
          default: false
        }
      },
      mounted () {
        store.dispatch('feedback/getFeedbackConfiguration');
      },
      methods: {
        ...mapActions('navigation', ['fetchResults']),
        ...mapActions('login', ['logOut', 'selectedDepartmentChange', 'fetchDepartmentResults']),
        collapseSidebar () {
          this.collapsed = !this.collapsed
          this.$emit('sidebarToggleEvent');
        },
        initNavigation (results) {
          this.navigationArray = (results.navigationItems || []).map(
          ({ type, title, childNodes, relativeUri }) =>
          ({ child: childNodes ? childNodes.map(({ title, type, relativeUri }) =>
          ({ title, type, href: relativeUri, active: false })) : childNodes,
            href: relativeUri,
            title,
            type
          }));
          const userObject = {
            'type': 'user',
            'child': [
                { title: 'Mijn gegevens', href: '/gegevens' },
                { title: 'Uitloggen', type: 'Logout', href: '/logout' }
            ]
          }
  
          this.instititionIds = this.availableDepartments.map(({ ppwRecId, name }) => ({ ppwRecId: ppwRecId, title: name.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') }));
          this.addDepartmentSelector = this.instititionIds.map(id => ({...id, id: 'department-selector'}))
            let institutionObject = {
            'title': 'Mijn afdelingen',
            'child': this.addDepartmentSelector,
            'type': 'department-items'
            }
          if (this.availablePortals.portals.length > 1) {
            this.portalDetails = this.availablePortals.portals.map(({ code, displayName }) => ({ code: code, title: displayName }));
            this.addPortalSelector = this.portalDetails.map(id => ({...id, id: 'portal-selector'}))
            let activePortalIndex = this.portalDetails.findIndex(portal => portal.code === this.availablePortals.activePortalCode)
            this.addPortalSelector.forEach((portal) => {
                portal.active = portal.code === this.availablePortals.activePortalCode ? true : false
            })
            let portalObject = {
              'title': this.portalDetails.length > 0 && activePortalIndex > 0 ? this.portalDetails[activePortalIndex].title : this.portalDetails[0].title,
              'child': this.addPortalSelector,
              'type': 'portal-items'
            }
            this.navigationArray.unshift(userObject, institutionObject, portalObject)
          } else {
            this.navigationArray.unshift(userObject, institutionObject)
          }
          let departmentArrayIndex = this.navigationArray.findIndex(navItem => navItem.type === 'department-items')
          let departmentArray = this.navigationArray[departmentArrayIndex].child;
          const selectedNavigationDepartment = departmentArray.find(childItem => childItem.ppwRecId === this.activeDepartment.ppwRecId)
          // Remove selected department from current index
          departmentArray.filter(item => item !== selectedNavigationDepartment)
          departmentArray.forEach((department) => {
            department.active = department.ppwRecId === selectedNavigationDepartment.ppwRecId ? true : false
          })
          this.navigationArray[departmentArrayIndex].child = departmentArray
        },
        onItemClick (item) {
          if(!item) {
            return
          }
          if(item.href || item === '/') {
            router.push(item.href || item)
          }
          this.contentDropDownDetails.forEach((menuItem) => {
            if (["Dashboard", "AboutMediq", "AboutPrescribingSystem"].indexOf(menuItem.type) > -1) {
              menuItem.child.forEach((subItem) => {
                subItem.active = subItem.title === item.title ? true : false
              })
            }
          })
          if (item.id === 'portal-selector') {
            this.changePortal(item.code)
          }
          if (item.id === 'department-selector') {
            store.dispatch('login/selectedDepartmentChange', item.ppwRecId).then((response) => {
              router.push('/')
              store.dispatch('login/fetchDepartmentResults')
              store.dispatch('navigation/fetchResults')
              pushDepartmentChangedEvent({});
            })
          }
          if (item.type === 'Logout') {
            formLogout().then(r => {
              store.commit('prescriber/setPrescriberChatIframe', false)
              window.location.replace("/?" + Math.random());
            });
          }
          if (item.type === 'GiveYourOpinion') {
            EventBus.$emit('showFeedbackForm')
          }
          if (item.type === 'Contact') {
            EventBus.$emit('showContactForm')
          }
          if (item.type === 'Pien') {
            window.open('https://www.mediqcombicare.nl/pien');
          }
          if (item.type === 'SSO') {
            router.push('/')
            window.open(item.href, '_blank');
          }
        },
        changePortal (portalCode) {
          pushActivePortalCode(portalCode);
          location.replace("/"); // reload page, right now there are too much dependencies on the damn store.
        }
      }
    }
  </script>
